import { t } from "i18next";
import { Toastr } from "neetoui";
import Papa from "papaparse";
import { prop } from "ramda";
import { string } from "yup";

const isValidEmail = email => string().email().isValidSync(email);

export const createEmailOptions = (emails = []) =>
  emails.map(email => ({
    label: email,
    value: email,
    valid: isValidEmail(email),
  }));

export const parseCsvEmails = (file, onSuccess) => {
  Papa.parse(file, {
    header: true,
    skipEmptyLines: true,
    transformHeader: h => h.toLowerCase().replace(/\W/g, ""),
    complete: results => {
      const isEmailFieldPresent = results.meta.fields?.includes("email");
      if (isEmailFieldPresent) {
        const emails = results.data
          .filter(prop("email"))
          .map(item => item.email.trim());
        onSuccess(createEmailOptions(emails));
      } else {
        Toastr.error(t("neetoMolecules.sendToFields.errors.invalidCsv"));
      }
    },
  });
};
